import React from "react";
import { Redirect,useParams } from "react-router";
import useRoles from "../Hooks/useRoles";
 
export function RedirectCandidato(){
        const [role, roles] = useRoles();
        const {id} = useParams<{id:string}>();
        switch (role) {
            case "applicant":
                return <Redirect  to={`/user/Candidato/${id}`} />
            case "company":
                return <Redirect  to={`/company/Candidato/${id}`} />
            case "institute":
                return <Redirect  to={`/CentroFormacion/Candidato/${id}`} />
            default:
                return <Redirect to="/"/>
        }
}

export function RedirectEmpresa(){
    const [role, roles] = useRoles();
    const {id} = useParams<{id:string}>();
    switch (role) {
        case "applicant":
            return <Redirect  to={`/user/PerfilEmpresa/${id}`} />
        case "company":
            return <Redirect  to={`/company/Empresa/${id}`} />
        case "institute":
            return <Redirect  to={`/CentroFormacion/Empresa/${id}`} />
        default:
            return <Redirect to="/"/>
    }

}

export function RedirectCentro(){
    const [role, roles] = useRoles();
    const {id} = useParams<{id:string}>();
}

export function RedirectVacante(){
    const [role, roles] = useRoles();
    const {id} = useParams<{id:string}>();
    switch (role) {
        case "applicant":
            return <Redirect  to={`/user/Vacante/${id}`} />
        case "company":
            return <Redirect  to={`/company/DetalleCurso/${id}`} />
        case "institute":
            return <Redirect  to={`/CentroFormacion/DetalleCurso/${id}`} />
        default:
            return <Redirect to="/"/>
    }
}

export function RedirectCurso(){
    const [role, roles] = useRoles();
    const {id} = useParams<{id:string}>();
    switch (role) {
        case "applicant":
            return <Redirect  to={`/user/DetalleCurso/${id}`} />
        case "company":
            return <Redirect  to={`/company/DetalleCurso/${id}`} />
        case "institute":
            return <Redirect  to={`/CentroFormacion/DetalleCurso/${id}`} />
        default:
            return <Redirect to="/"/>
    }
}
